import { render, staticRenderFns } from "./SafetySuppliesApply.vue?vue&type=template&id=a8974a20&scoped=true"
import script from "./SafetySuppliesApply.vue?vue&type=script&lang=js"
export * from "./SafetySuppliesApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8974a20",
  null
  
)

export default component.exports